var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-details row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"mb-1 text-muted font-12"},[_c('currency-display',{attrs:{"amount":_vm.breakdown.amount,"showCurrencyCode":true,"applyDecimals":true}}),_c('br'),_vm._v(" "+_vm._s(_vm.__('messages.colombians_vat_messages')))],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }